// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"23da3d91","268":"cac2d085","312":"fff0e36d","339":"60b72a82","375":"4dd82f4f","551":"f08f88f6","579":"51465cfd","638":"76ff8f4b","640":"11126420","800":"742a87ec"}[chunkId] + ".chunk.js";
};